import React from 'react';
import myBenefitzLogo from '../../../../Data/logo.png';
import './LogoShow.css';

function LogoShow() {
    return (
        <footer className="footer">
            {myBenefitzLogo ? (
                <img
                    src={myBenefitzLogo}
                    alt="MyBenefitz Logo"
                    className="benefitz-logo"
                />
            ) : (
                <span className="loading-text">...</span>
            )}
        </footer>
    );
}

export default LogoShow;
